import { Form, Input, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InsideHeader from "../../components/InsideHeader";
import { fetchAudit } from "../../features/dropdown/dropdownSlice";
import { formatDateTime } from "../../utils";

export default function AuditTrailTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const { auditData, loading, auditCount } = useSelector(
    (state) => state.dropdown
  );

  const [searchText, setSearchText] = useState("");

  const filterDataList = searchText
    ? auditData?.filter((item) =>
        item?.lastModifiedBy?.toLowerCase().includes(searchText.toLowerCase()) || 
        item?.tableName?.toLowerCase().includes(searchText.toLowerCase()) ||
        item?.actionType?.toLowerCase().includes(searchText.toLowerCase())
      )
    : auditData;

  const columns = [
    {
      title: "Action Type",
      dataIndex: "actionType",
      sorter: (a, b) => a.actionType.localeCompare(b.actionType),
    },
    {
      title: "Last Modified By",
      dataIndex: "lastModifiedBy",
      sorter: (a, b) => a.lastModifiedBy.localeCompare(b.lastModifiedBy),
    },
    {
      title: "Date and Time",
      dataIndex: "changedOn",
      render: (item) => <div>{formatDateTime(item)}</div>,
      sorter: (a, b) => a.changedOn.localeCompare(b.changedOn),
    },
    {
      title: "Table Name",
      dataIndex: "tableName",
      sorter: (a, b) => a.tableName.localeCompare(b.tableName),
    },
  ];

  const expandedColumns = [
    {
      title: "Field",
      dataIndex: "field",
    },
    {
      title: "Old Value",
      dataIndex: "oldValue",
    },
    {
      title: "New Value",
      dataIndex: "newValue",
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchAuditData(page, size) {
    await dispatch(
      fetchAudit({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchAuditData();
  }, []);

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Audit Trail Information"
        subtitle="Have a view of who performed an action within your institution"
        back={false}
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            form={form}
          >
            <div className="flex items-center w-full mt-[1.25rem]">
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search audits"
                className="text-[16px] font-[400] flex-row-reverse search-input"
              />
            </div>
          </Form>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <Table
              rowKey="auditId"
              columns={columns}
              dataSource={filterDataList}
              expandable={{
                expandedRowRender: (record) => {
                  const oldValues = record?.oldValues ? JSON.parse(record?.oldValues) : {};
                  const newValues = record?.newValues ? JSON.parse(record?.newValues) : {};

                  const fieldData = Object.keys({ ...oldValues, ...newValues })
                    .map((key) => ({
                      field: key,
                      oldValue: oldValues[key] ?? "N/A",
                      newValue: newValues[key] ?? "N/A",
                    }))
                    .filter((item) => item?.oldValue !== item?.newValue);  

                  return fieldData.length > 0 ? (
                    <Table
                      className="audit-inner"
                      rowKey={(item) => item?.field}
                      columns={expandedColumns}
                      dataSource={fieldData}
                      pagination={false}
                    />
                  ) : (
                    <div>No changes</div>
                  );
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
